const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 0.5,
      maxZoomLevel: 'fill',
      scaleMode: 'zoom',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
      this.addNextPrev()
    })

    this.photoSwipeInstance.on('beforeOpen', () => {
      this.externalEls.fixedbar.element.classList.add(
        'prd-FixedBar-photoswipe',
      )
    })
    this.photoSwipeInstance.on('close', () => {
      this.externalEls.fixedbar.element.classList.remove(
        'prd-FixedBar-photoswipe',
      )
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  addNextPrev () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'paging',
      className: 'pswp-Action_Buttons',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const prevEl = document.createElement('button')
        prevEl.type = 'button'
        prevEl.className = 'pswp-Action_Button'
        prevEl.textContent = window.theme.strings.previous
        prevEl.onclick = () => {
          pswp.goTo(pswp.currIndex - 1)
        }

        const nextEl = document.createElement('button')
        nextEl.type = 'button'
        nextEl.className = 'pswp-Action_Button'
        nextEl.textContent = window.theme.strings.next
        nextEl.onclick = () => {
          pswp.goTo(pswp.currIndex + 1)
        }

        element.appendChild(prevEl)
        element.appendChild(nextEl)

        pswp.on('change', () => {
          prevEl.setAttribute('aria-hidden', pswp.currIndex === 0)
          nextEl.setAttribute(
            'aria-hidden',
            pswp.currIndex + 1 === pswp.getNumItems(),
          )
        })
      },
    })
  }

  get closeSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m6.5 13.5 7-7M13.5 13.5l-7-7"/>
    </svg>`
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
